const SENTRY_HUBS_KEY = 'sentryHubs';
const SENTRY_MAIN_HUB_KEY = 'sentryMainHub';
const SENTRY_GLOBAL_HUB_KEY = 'sentryGlobalHub';
const getHubMap = globalConfig => {
  if (!globalConfig.getStateValue(SENTRY_HUBS_KEY)) {
    globalConfig.setStateValue(SENTRY_HUBS_KEY, new Map());
  }
  return globalConfig.getStateValue(SENTRY_HUBS_KEY);
};
export const getMainHub = globalConfig => {
  var _globalConfig$getStat;
  return (_globalConfig$getStat = globalConfig.getStateValue(SENTRY_MAIN_HUB_KEY)) != null ? _globalConfig$getStat : null;
};
export const setMainHub = (hub, globalConfig) => globalConfig.setStateValue(SENTRY_MAIN_HUB_KEY, hub);
export const getGlobalHub = globalConfig => {
  var _globalConfig$getStat2;
  return (_globalConfig$getStat2 = globalConfig.getStateValue(SENTRY_GLOBAL_HUB_KEY)) != null ? _globalConfig$getStat2 : null;
};
export const setGlobalHub = (hub, globalConfig) => globalConfig.setStateValue(SENTRY_GLOBAL_HUB_KEY, hub);
export const getHubForArtifact = (artifactId, globalConfig) => {
  var _getHubMap$get;
  return (_getHubMap$get = getHubMap(globalConfig).get(artifactId)) != null ? _getHubMap$get : null;
};
export const setHubForArtifact = (hub, artifactId, globalConfig) => getHubMap(globalConfig).set(artifactId, hub);
export const getHubForDsn = (dsn, globalConfig) => {
  var _getHubMap$get2;
  return (_getHubMap$get2 = getHubMap(globalConfig).get(dsn)) != null ? _getHubMap$get2 : null;
};
export const setHubForDsn = (hub, dsn, globalConfig) => getHubMap(globalConfig).set(dsn, hub);
//# sourceMappingURL=sentry-plugin-state.js.map